import { createValidator, ErrorObject, required } from 'util/validation'

import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta09Model } from './model-consultaSeguimentoPergunta09'
import { hasPergunta09TrazPraVoceAnySim } from './utils-consultaSeguimentoPergunta09'

export const validatorConsultaSeguimentoPergunta09 = createValidator<ConsultaSeguimentoPergunta09Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_09_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta09Model, errors: ErrorObject<ConsultaSeguimentoPergunta09Model>) => {
    errors.PERGUNTA_09_TRAZ_PRA_VOCE = required(values?.PERGUNTA_09_TRAZ_PRA_VOCE)

    if (hasPergunta09TrazPraVoceAnySim(values?.PERGUNTA_09_TRAZ_PRA_VOCE)) {
      errors.PERGUNTA_09_SO_PARA_MOSTRAR = required(values?.PERGUNTA_09_SO_PARA_MOSTRAR)
    }

    return errors
  }
)
